module.exports = __webpack_public_path__ + "img/jiesuandan2.5256dbdd.png";